import {DISCLOSURE_CATEGORY_ICONS, DISCLOSURE_TYPE_ICON_MAPPING} from '@stubhub/disclosure-utils';

import disclosureMessages from './messages';

const setListingAttributesDisclosureCategory = (listings = [], seatTraits = []) => {
  return listings && seatTraits && seatTraits.length
    ? listings.map((listing) => {
        const {listingAttributeList = []} = listing;
        const listingAttributeListWithCategories = listingAttributeList.reduce((attributeCategories, attribute) => {
          const seatTrait = seatTraits.find((trait) => trait.id === attribute) || {};
          attributeCategories[attribute] =
            DISCLOSURE_TYPE_ICON_MAPPING[seatTrait.type] || DISCLOSURE_CATEGORY_ICONS.RESTRICTIONS_LIMITATIONS;

          return attributeCategories;
        }, {});

        return {
          ...listing,
          listingAttributeListWithCategories,
        };
      })
    : [];
};

export {disclosureMessages};

export default setListingAttributesDisclosureCategory;
